import { CoordinatesModel } from 'types/models/coordinates'

export const toGoogleLatLng = ({ latitude, longitude }: CoordinatesModel) =>
  new window.google.maps.LatLng(latitude, longitude)
